import styled from 'styled-components'

const gridTemplateAreas = (
  noImage: boolean,
  titleOnTop: boolean,
  $reverse: boolean,
  noTitle: boolean
) => {
  if (noTitle) return $reverse ? `'image content'` : `'content image'`

  if (noImage) {
    return `'title' 'content'`
  }

  if (titleOnTop) {
    return $reverse
      ? `'title title' 'content image'`
      : `'title title' 'image content'`
  } else {
    return $reverse
      ? `'title image' 'content image'`
      : `'image title' 'image content'`
  }
}

export const MainContainer = styled.div<{
  noImage: boolean
  titleOnTop: boolean
  $reverse: boolean
  noTitle: boolean
}>`
  display: grid;
  gap: 24px;

  @media (min-width: 768px) {
    grid-template-rows: auto auto;

    grid-template-areas: ${({ noImage, titleOnTop, $reverse, noTitle }) =>
      gridTemplateAreas(noImage, titleOnTop, $reverse, noTitle)};

    gap: 24px 64px;
  }
`

export const ArticleTitle = styled.h2<{ $color?: string }>`
  color: ${({ theme, $color }) => $color || theme.colors.blackText};
  font-size: 24px;
  font-weight: 600;
  line-height: 32px; /* 133.333% */
  margin: 0;

  @media (min-width: 768px) {
    grid-area: title;
    align-self: end;
    font-size: 32px;
    line-height: 48px; /* 150% */
  }
`

export const ArticleImage = styled.img``

export const ContentContainer = styled.div<{ noTitle: boolean }>`
  display: grid;
  row-gap: 16px;
  font-family: Barlow;

  @media (min-width: 768px) {
    grid-area: content;
    align-self: ${({ noTitle }) => (noTitle ? 'center' : 'start')};
  }
`

export const ArticleContent = styled.div<{ $textColor?: string }>`
  color: ${({ theme, $textColor }) => $textColor || theme.colors.blackText};
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: justify;

  @media (min-width: 768px) {
    font-size: 24px;
    line-height: 32px;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 24px;
  }
`

export const ArticleImageDocument = styled.div`
  width: 100%;

  > img {
    border-radius: 8px;
    width: 100%;
  }

  @media (min-width: 768px) {
    grid-area: image;
    align-self: center;
    max-width: 432px;
  }
`
